<template>
    <div class="screenshots-area mobile-space pt-100 pb-100">
        <div class="container">
            <div class="section-title">
                <div class="big-title"> 
                    <span class="sub-title-shadow text-capitalize">Dashboard</span>
                    <span class="sub-title text-uppercase">Dashboard</span>
                    <h2>Explore Our Powerful Admin Panel</h2>
                </div>
            </div>
            <div class="screenshots-swiper-slides">
                <carousel
                    :autoplay="5000"
                    :settings="settings"
                    :breakpoints="breakpoints"
                    :wrap-around="true"
                >
                    <slide 
                        v-for="(slide, index) in dashboard_screenshots" 
                        :key="index"
                    >
                        <div class="swiper-slide">
                            <img 
                                :src="$backendUrl + slide?.url" 
                                :alt="slide?.alternativeText || 'Dashboard Screenshot'" 
                                loading="lazy"
                            >
                        </div>
                    </slide>
                    
                    <template #addons>
                        <navigation>
                            <template #next>
                                <i class='ri-arrow-right-s-line'></i>
                            </template>
                            <template #prev>
                                <i class='ri-arrow-left-s-line'></i>
                            </template>
                        </navigation>
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

export default defineComponent({
    name: 'Screenshots',
    props: {
        dashboard_screenshots: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
            wrapAround: true,
        },
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            576: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 2.1,
                snapAlign: 'center',
            },
        },
    }),
});
</script>